import { Component, OnInit } from '@angular/core'
import { ApiService, UserInfo } from '../../../services/api.service'
import { environment } from '../../../../environments/environment'
import { ButtonComponent } from '@components/button/button.component'
import { CommonModule } from '@angular/common'
import { TranslateModule } from '@ngx-translate/core'
import { HomeLinksService } from '../../../services/home-links.service'

@Component({
    selector: 'app-ecosentino-banner',
    templateUrl: './ecosentino-banner.component.html',
    imports: [ButtonComponent, CommonModule, TranslateModule],
    standalone: true,
    // styleUrl: './home.component.scss',
})
export class EcosentinoBanner implements OnInit {
    userInfo: UserInfo
    protected readonly environment = environment

    constructor(private api: ApiService, private homeLinksService: HomeLinksService) {}

    ngOnInit(): void {
        this.api.userInfo.subscribe((userInfo) => (this.userInfo = userInfo))
    }

    disabled(){
        return !this.userInfo.mainMenu.items.find((item) => item.code === 'e-cosentino')

    }
    goToECosentino() {
        this.homeLinksService.goToECosentino()
    }
}
